/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
import { useState, useEffect, useCallback } from 'react';
import { useTheme } from '@mui/material/styles';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Switch,
  Tabs,
  Tab,
  FormControlLabel,
  useMediaQuery,
  Grid,
  Divider,
  Collapse,
  Box,
  Stack,
  Chip,
  IconButton,
  Tooltip,
} from '@mui/material';
import { sentenceCase, capitalCase } from 'change-case';
import { Link as RouterLink } from 'react-router-dom';

// components
import Iconify from '../../components/Iconify';
import EmptyContent from '../../components/EmptyContent';
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';

// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// format number
import { fCurrency } from '../../utils/formatNumber';
// sections
import { TransHead, PlanToolbar } from '../../sections/admin/user/list';
// axios
import axios from '../../utils/axios';

const TABLE_HEAD = [
  { id: 'my_trans_id', label: 'System ID', alignRight: false },
  { id: 'network', label: 'Network', alignRight: false },
  { id: 'plan_type', label: 'Plan Type', alignRight: false },
  { id: 'plan_name', label: 'Plan Name', alignRight: false },
  { id: 'card_name', label: 'Card Name', alignRight: false },
  { id: 'quantity', label: 'Quantity', alignRight: false },
  { id: 'load_pin', label: 'Load Pin', alignRight: false },
  { id: 'amount', label: 'Amount', alignRight: false },
  { id: 'oldbal', label: 'Old Bal', alignRight: false },
  { id: 'newbal', label: 'New Bal', alignRight: false },
  { id: 'transid', label: 'Client Reference ID', alignRight: false },
  { id: 'system', label: 'System', alignRight: false },
  { id: 'date', label: 'Purchased Date', alignRight: false },
  { id: 'plan_status', label: 'Plan Status', alignRight: false },
  { id: 'invioce', label: 'INVIOCE', alignRight: false },
];

const ACCOUNT_TABS = [
  {
    value: 'ALL',
    label: 'ALL',
  },
  {
    value: 1,
    label: 'Successful',
  },
  {
    value: 0,
    label: 'Processing',
  },
  {
    value: 2,
    label: 'Failed',
  },
];

export default function DataCardTransaction() {
  const theme = useTheme();
  const { themeStretch } = useSettings();
  const [userList, setUserList] = useState([]);
  const [page, setPage] = useState(0);
  const [load, SetLoad] = useState(true);
  const [totalPage, SetTotal] = useState(0);
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [dense, Setdense] = useState(false);
  const [isNotFound, SetNotFound] = useState(false);
  const [status, setStatus] = useState('ALL');
  const AccessToken = window.localStorage.getItem('accessToken');
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [expandedRows, setExpandedRows] = useState({});

  const initialize = useCallback(
    async (pag, adex = 5, status, search) => {
      const adex_page = pag > page ? pag + 1 : pag;
      SetLoad(true);
      try {
        const data = await axios.get(
          `/api/all/data_recharge_cards/${AccessToken}/secure?page=${adex_page}&adex=${adex}&status=${status}&search=${search}&database_name=data_card`
        );
        setUserList(data.data?.data_card.data);
        SetTotal(data.data?.data_card?.total);
        setPage(pag);
        SetNotFound(data.data?.data_card?.total === 0);
      } catch (_) {
        setUserList([]);
      } finally {
        SetLoad(false);
      }
    },
    [AccessToken, page]
  );

  useEffect(() => {
    initialize(page, rowsPerPage, status, filterName);
  }, [initialize, page, rowsPerPage, status, filterName]);

  const handleChangeRowsPerPage = useCallback(
    (event) => {
      const newRowsPerPage = parseInt(event.target.value, 10);
      setRowsPerPage(newRowsPerPage);
      initialize(0, newRowsPerPage, status, filterName);
      setPage(0);
    },
    [initialize, status, filterName]
  );

  const handleFilterByName = useCallback(
    async (filterName) => {
      setFilterName(filterName);
      setPage(0);
      await initialize(0, rowsPerPage, status, filterName);
      SetNotFound(false);
      SetLoad(false);
    },
    [initialize, rowsPerPage, status]
  );

  const handleChangeDense = useCallback((event) => {
    Setdense(event.target.checked);
  }, []);

  const handleRowToggle = useCallback((transid) => {
    setExpandedRows((prev) => ({
      ...prev,
      [transid]: !prev[transid],
    }));
  }, []);

  const MobileAccordionRow = useCallback(
    ({ row, expanded }) => {
      const {
        my_trans_id,
        network,
        plan_type,
        plan_name,
        card_name,
        quantity,
        load_pin,
        amount,
        oldbal,
        newbal,
        system,
        plan_date,
        plan_status,
        transid,
      } = row;

      let statusProps = { label: '', color: 'default', icon: null };
      if (plan_status === 1) {
        statusProps = {
          label: 'Successful',
          color: 'success',
          icon: <Iconify icon="eva:checkmark-circle-2-fill" width={18} height={18} />,
        };
      } else if (plan_status === 0) {
        statusProps = {
          label: 'Processing',
          color: 'warning',
          icon: <Iconify icon="eva:clock-outline" width={18} height={18} />,
        };
      } else if (plan_status === 2) {
        statusProps = {
          label: 'Failed',
          color: 'error',
          icon: <Iconify icon="eva:close-circle-fill" width={18} height={18} />,
        };
      }

      const handleToggle = () => handleRowToggle(transid);

      return (
        <Card
          sx={{
            mb: 1,
            borderRadius: 2,
            boxShadow: 1,
            border: expanded ? `1px solid ${theme.palette.primary.main}` : '1px solid transparent',
            transition: 'all 0.3s ease',
          }}
        >
          <Box
            sx={{ p: 2, cursor: 'pointer', '&:hover': { backgroundColor: theme.palette.action.hover } }}
            onClick={handleToggle}
          >
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Box sx={{ flex: 1 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                  {network}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {plan_name}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Chip
                  label={statusProps.label}
                  color={statusProps.color}
                  icon={statusProps.icon}
                  size="small"
                  sx={{ fontWeight: 600 }}
                />
                <IconButton size="small">
                  <Iconify icon={expanded ? 'eva:chevron-up-fill' : 'eva:chevron-down-fill'} width={20} height={20} />
                </IconButton>
              </Box>
            </Stack>
          </Box>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Box sx={{ px: 2, pb: 2 }}>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                    System ID
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                    {my_trans_id}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                    Plan Type
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                    {plan_type}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                    Card Name
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                    {card_name}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                    Quantity
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                    {quantity}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                    Load Pin
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                    {load_pin}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                    Amount
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                    ₦{fCurrency(amount)}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                    Old Balance
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                    ₦{fCurrency(oldbal)}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                    Client Reference ID
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                    ₦{fCurrency(transid)}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                    New Balance
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                    ₦{fCurrency(newbal)}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                    System
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                    {system}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                    Purchase Date
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500, mb: 2 }}>
                    {plan_date}
                  </Typography>
                </Grid>
              </Grid>
              <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
                <Tooltip title="Generate Invoice">
                  <IconButton
                    color="primary"
                    component={RouterLink}
                    to={
                      plan_status === 1
                        ? `${PATH_DASHBOARD.general.invioce}/${my_trans_id}/success_data_card`
                        : `${PATH_DASHBOARD.general.invioce}/${my_trans_id}/data_card`
                    }
                    sx={{
                      borderRadius: 2,
                      border: `1px solid ${theme.palette.primary.main}`,
                      '&:hover': { backgroundColor: theme.palette.primary.main, color: 'white' },
                    }}
                  >
                    <Iconify icon="eva:file-text-outline" width={22} height={22} />
                  </IconButton>
                </Tooltip>
              </Stack>
            </Box>
          </Collapse>
        </Card>
      );
    },
    [handleRowToggle, theme]
  );

  const renderMobileView = useCallback(() => {
    if (load) {
      return (
        <Box sx={{ mt: 2 }}>
          {[...Array(rowsPerPage)].map((_, idx) => (
            <Card key={idx} sx={{ mb: 1, p: 2, borderRadius: 2 }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ width: 100, height: 16, bgcolor: 'grey.200', borderRadius: 1, mb: 1 }} />
                  <Box sx={{ width: 80, height: 12, bgcolor: 'grey.200', borderRadius: 1 }} />
                </Box>
                <Box sx={{ width: 80, height: 24, bgcolor: 'grey.200', borderRadius: 1 }} />
              </Stack>
            </Card>
          ))}
        </Box>
      );
    }
    if (userList.length > 0) {
      return (
        <Box sx={{ mt: 2 }}>
          {userList.map((row) => (
            <MobileAccordionRow key={row.my_trans_id} row={row} expanded={expandedRows[row.my_trans_id] || false} />
          ))}
        </Box>
      );
    }
    return (
      <Box sx={{ mt: 2 }}>
        <Card sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
          <EmptyContent
            title="No Data Card Transactions"
            description="No data card transactions found for your current filter."
            img="/upload/notfound.png"
          />
        </Card>
      </Box>
    );
  }, [load, rowsPerPage, userList, expandedRows, MobileAccordionRow]);

  const renderDesktopView = useCallback(
    () => (
      <Scrollbar>
        <TableContainer sx={{ minWidth: 900, borderRadius: 2, boxShadow: 0 }}>
          <Table size={dense ? 'small' : 'medium'}>
            <TransHead order={'asc'} orderBy={'id'} headLabel={TABLE_HEAD} rowCount={userList.length} />
            {load ? (
              <TableBody>
                {[...Array(rowsPerPage)].map((_, idx) => (
                  <TableRow key={idx}>
                    {TABLE_HEAD.map((col) => (
                      <TableCell key={col.id}>
                        <Box sx={{ width: 80, height: 16, bgcolor: 'grey.200', borderRadius: 1 }} />
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                {userList.length > 0 ? (
                  userList.map((row) => {
                    const {
                      my_trans_id,
                      network,
                      plan_type,
                      plan_name,
                      card_name,
                      quantity,
                      load_pin,
                      amount,
                      oldbal,
                      newbal,
                      system,
                      plan_date,
                      plan_status,
                      transid,
                    } = row;
                    let statusProps = { label: '', color: 'default', icon: null };
                    if (plan_status === 1) {
                      statusProps = {
                        label: 'Successful',
                        color: 'success',
                        icon: <Iconify icon="eva:checkmark-circle-2-fill" width={18} height={18} />,
                      };
                    } else if (plan_status === 0) {
                      statusProps = {
                        label: 'Processing',
                        color: 'warning',
                        icon: <Iconify icon="eva:clock-outline" width={18} height={18} />,
                      };
                    } else if (plan_status === 2) {
                      statusProps = {
                        label: 'Failed',
                        color: 'error',
                        icon: <Iconify icon="eva:close-circle-fill" width={18} height={18} />,
                      };
                    }
                    return (
                      <TableRow hover key={my_trans_id} tabIndex={-1} role="checkbox">
                        <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
                          <Typography variant="subtitle2" noWrap>
                            {my_trans_id}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">{network}</TableCell>
                        <TableCell align="left">{plan_type}</TableCell>
                        <TableCell align="left">{plan_name}</TableCell>
                        <TableCell align="left">{card_name}</TableCell>
                        <TableCell align="left">{quantity}</TableCell>
                        <TableCell align="left">{load_pin}</TableCell>
                        <TableCell align="left">₦{fCurrency(amount)}</TableCell>
                        <TableCell align="left">₦{fCurrency(oldbal)}</TableCell>
                        <TableCell align="left">₦{fCurrency(newbal)}</TableCell>
                        <TableCell align="left">{transid}</TableCell>
                        <TableCell align="left">{system}</TableCell>
                        <TableCell align="left">{plan_date}</TableCell>
                        <TableCell align="left">
                          <Chip
                            label={statusProps.label}
                            color={statusProps.color}
                            icon={statusProps.icon}
                            size="small"
                            sx={{ fontWeight: 600 }}
                          />
                        </TableCell>
                        <TableCell align="left">
                          <Tooltip title="Generate Invoice">
                            <IconButton
                              color="primary"
                              component={RouterLink}
                              to={
                                plan_status === 1
                                  ? `${PATH_DASHBOARD.general.invioce}/${my_trans_id}/success_data_card`
                                  : `${PATH_DASHBOARD.general.invioce}/${my_trans_id}/data_card`
                              }
                            >
                              <Iconify icon="eva:file-text-outline" width={22} height={22} />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={TABLE_HEAD.length} align="center" sx={{ py: 5 }}>
                      <EmptyContent
                        title="No Data Card Transactions"
                        description="No data card transactions found for your current filter."
                        img="/upload/notfound.png"
                      />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Scrollbar>
    ),
    [dense, load, rowsPerPage, userList]
  );

  const getTabColor = useCallback((theme, status, tabValue) => {
    const isActive = status === tabValue;
    return isActive ? theme.palette.primary.contrastText : theme.palette.text.secondary;
  }, []);

  const getTabBackground = useCallback((theme, status, tabValue) => {
    const isActive = status === tabValue;
    return isActive ? theme.palette.primary.main : 'transparent';
  }, []);

  const handleTabChange = useCallback(
    (e, value) => {
      setStatus(value);
      initialize(page, rowsPerPage, value, filterName);
    },
    [initialize, page, rowsPerPage, filterName]
  );

  const handlePageChange = useCallback(
    (e, newPage) => {
      initialize(newPage, rowsPerPage, status, filterName);
    },
    [initialize, rowsPerPage, status, filterName]
  );

  return (
    <Page title="Transaction: Data Card">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Data Card Printing Transactions"
          links={[{ name: 'Dashboard', href: PATH_DASHBOARD.general.app }, { name: 'List' }]}
        />

        <Card>
          <Box sx={{ mb: 3, mt: 3, display: 'flex', justifyContent: 'center' }}>
            <Box
              sx={{
                display: 'inline-flex',
                borderRadius: 999,
                px: 1,
                py: 0.5,
                background: (theme) =>
                  theme.palette.mode === 'light' ? theme.palette.background.neutral : theme.palette.grey[900],
                minHeight: 48,
                maxWidth: '100%',
                boxShadow: 'none',
                border: 'none',
              }}
            >
              <Tabs
                value={status}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{ sx: { display: 'none' } }}
                sx={{
                  minHeight: 40,
                  '& .MuiTab-root': {
                    minWidth: 100,
                    px: 2,
                  },
                }}
              >
                {ACCOUNT_TABS.map((tab) => (
                  <Tab
                    disableRipple
                    key={tab.value}
                    label={capitalCase(tab.label)}
                    value={tab.value}
                    sx={{
                      minWidth: 70,
                      px: 1.5,
                      py: 1,
                      borderRadius: 999,
                      fontWeight: 600,
                      fontSize: 16,
                      color:
                        status === tab.value
                          ? theme.palette.primary.contrastText
                          : getTabColor(theme, status, tab.value),
                      background:
                        status === tab.value ? theme.palette.primary.main : getTabBackground(theme, status, tab.value),
                      boxShadow: 'none',
                      border: 'none',
                      zIndex: status === tab.value ? 1 : 0,
                      transition: 'all 0.2s',
                    }}
                  />
                ))}
              </Tabs>
            </Box>
          </Box>

          <PlanToolbar filterName={filterName} onFilterName={handleFilterByName} />

          {isMobile ? renderMobileView() : renderDesktopView()}

          <FormControlLabel
            control={<Switch checked={dense} onChange={handleChangeDense} />}
            label="Dense padding"
            sx={{ textAlign: 'left' }}
          />

          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={totalPage}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
